// import { useState } from "react";
// import { useForm } from "react-hook-form";
// import { Eye, EyeOff } from "lucide-react"
// import { useNavigate } from "react-router-dom";
// import { Button } from "../components/ui/button";
// import { Input } from "../components/ui/input";
// import { Label } from "../components/ui/label";
// import {
//   Card,
//   CardContent,
//   CardDescription,
//   CardHeader,
//   CardTitle,
//   CardFooter,
// } from "../components/ui/card";
// import { useToast } from "../hooks/useToast";
// import { UserPlus } from "lucide-react";
// import { useAuth } from "../contexts/AuthContext";

// type RegisterForm = {
//   email: string;
//   password: string;
//   role: string;
// };

// export function Register() {
//   const [showPassword, setShowPassword] = useState(false)
//   const [loading, setLoading] = useState(false);
//   const { toast } = useToast();
//   const { register: registerUser } = useAuth();
//   const navigate = useNavigate();
//   const { register, handleSubmit, setValue } = useForm<RegisterForm>({
//     defaultValues: {
//       role: "admin",
//     },
//   });

//   useState(() => {
//     setValue("role", "admin");
//   }, [setValue]);

//   console.log("Register.tsx: Component mounted/rendered");

//   const onSubmit = async (data: RegisterForm) => {
//     try {
//       console.log("Register.tsx: Form submission started");
//       console.log("Register.tsx: Form data received:", {
//         email: data.email,
//         password: "***",
//       });

//       setLoading(true);
//       console.log("Register.tsx: Loading state set to true");

//       console.log("Register.tsx: Calling registerUser from AuthContext");
//       await registerUser(data.email, data.password, data.role);

//       console.log(
//         "Register.tsx: Registration successful, showing success toast"
//       );
//       toast({
//         title: "Success",
//         description: "Account created successfully",
//       });

//       console.log("Register.tsx: Navigating to login page");
//       navigate("/");
//       console.log("Register.tsx: Navigation completed");
//     } catch (error) {
//       console.error("Register.tsx: Registration error occurred:", error);
//       console.error("Register.tsx: Error message:", (error as any)?.message);

//       console.log("Register.tsx: Showing error toast");
//       toast({
//         variant: "destructive",
//         title: "Error",
//         description: (error as any)?.message,
//       });
//     } finally {
//       console.log("Register.tsx: Setting loading state to false");
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-background to-secondary p-4">
//       <Card className="w-full max-w-md">
//         <CardHeader>
//           <CardTitle>Create an account</CardTitle>
//           <CardDescription>Enter your details to get started</CardDescription>
//         </CardHeader>
//         <CardContent>
//           <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
//             <div className="space-y-2">
//               <Label htmlFor="email">Email</Label>
//               <Input
//                 id="email"
//                 type="email"
//                 placeholder="Enter your email"
//                 {...register("email", { required: true })}
//               />
//             </div>
//              <div className="space-y-2 relative">
//               <Label htmlFor="password">Password</Label>
//               <div className="relative">
//                 <Input
//                   id="password"
//                   type={showPassword ? "text" : "password"}
//                   placeholder="Enter your password"
//                   {...register("password", { required: true })}
//                 />
//                 <button
//                   type="button"
//                   onClick={() => setShowPassword((prev) => !prev)}
//                   className="absolute right-2 top-2.5 text-muted-foreground"
//                 >
//                   {!showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
//                 </button>
//               </div>
//               <p
//                 onClick={() => navigate("/forgot-password")}
//                 className="text-sm text-blue-600 hover:underline cursor-pointer text-right"
//               >
//                 Forgot Password?
//               </p>
//             </div>

//             <Button type="submit" className="w-full" disabled={loading}>
//               {loading ? (
//                 "Loading..."
//               ) : (
//                 <>
//                   <UserPlus className="mr-2 h-4 w-4" />
//                   Create Account
//                 </>
//               )}
//             </Button>
//           </form>
//         </CardContent>
//         <CardFooter className="flex justify-center">
//           <Button
//             variant="link"
//             className="text-sm text-muted-foreground"
//             onClick={() => {
//               console.log("Register.tsx: Navigate to login button clicked");
//               navigate("/login");
//             }}
//           >
//             Already have an account? Sign in
//           </Button>
//         </CardFooter>
//       </Card>
//     </div>
//   );
// }


import { useState } from "react";
import { useForm } from "react-hook-form";
import { Eye, EyeOff, UserPlus, Lock, Mail, Sparkles, Shield, Users, User } from "lucide-react"
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  CardFooter,
} from "../components/ui/card";
import { useToast } from "../hooks/useToast";
import { useAuth } from "../contexts/AuthContext";

type RegisterForm = {
  email: string;
  password: string;
  role: string;
  first_name: string;
  last_name: string;
};

export function Register() {
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false);
  const { toast } = useToast();
  const { register: registerUser } = useAuth();
  const navigate = useNavigate();
  const { register, handleSubmit, setValue } = useForm<RegisterForm>({
    defaultValues: {
      role: "admin",
    },
  });

  useState(() => {
    setValue("role", "admin");
  }, [setValue]);

  console.log("Register.tsx: Component mounted/rendered");

  const onSubmit = async (data: RegisterForm) => {
    try {
      console.log("Register.tsx: Form submission started");
      console.log("Register.tsx: Form data received:", {
        email: data.email,
        password: "***",
        first_name: data.first_name,
        last_name: data.last_name,
      });

      setLoading(true);
      console.log("Register.tsx: Loading state set to true");

      console.log("Register.tsx: Calling registerUser from AuthContext");
      await registerUser(data.email, data.password, data.role, data.first_name, data.last_name);

      console.log(
        "Register.tsx: Registration successful, showing success toast"
      );
      toast({
        title: "Success",
        description: "Account created successfully",
      });

      console.log("Register.tsx: Navigating to login page");
      navigate("/login");
      console.log("Register.tsx: Navigation completed");
    } catch (error) {
      console.error("Register.tsx: Registration error occurred:", error);
      console.error("Register.tsx: Error message:", (error as any)?.message);

      console.log("Register.tsx: Showing error toast");
      toast({
        variant: "destructive",
        // title: "Error",
        description: (error as any)?.message,
      });
    } finally {
      console.log("Register.tsx: Setting loading state to false");
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900">
      {/* Background decorative elements */}
      <div className="absolute inset-0 z-0">
        {/* Animated floating shapes */}
        <div className="absolute top-10 left-10 w-72 h-72 bg-gradient-to-r from-emerald-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div>
        <div className="absolute bottom-10 right-10 w-72 h-72 bg-gradient-to-l from-cyan-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/3 w-64 h-64 bg-gradient-to-r from-blue-100 to-transparent rounded-full mix-blend-multiply filter blur-xl opacity-60 animate-pulse delay-500"></div>
        
        {/* Grid pattern */}
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik02MCAwSDB2NjBoNjBWMHpNMCAwaDYwdjYwSDBWMHoiIGZpbGw9InJnYmEoMCwgMCwgMCwgMC4wMSkiLz48L2c+PC9zdmc+')] opacity-20"></div>
      </div>

      {/* Sparkles decoration */}
      <div className="absolute top-6 right-6 text-emerald-400 dark:text-emerald-300 opacity-60">
        <Sparkles size={24} className="animate-spin-slow" />
      </div>
      <div className="absolute bottom-6 left-6 text-cyan-400 dark:text-cyan-300 opacity-60">
        <Sparkles size={20} className="animate-spin-slow" />
      </div>

      {/* Register Card */}
      <div className="relative z-10 w-full max-w-md mx-4">
        <Card className="w-full backdrop-blur-sm bg-white/90 dark:bg-gray-800/90 border-gray-200 dark:border-gray-700 shadow-2xl shadow-emerald-500/10 dark:shadow-emerald-500/5 transition-all duration-300 hover:shadow-2xl hover:shadow-emerald-500/20">
          <CardHeader className="text-center pb-6">
            <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-gradient-to-br from-emerald-500 to-cyan-600 shadow-lg">
              <UserPlus className="h-8 w-8 text-white" />
            </div>
            <CardTitle className="text-2xl font-bold text-gray-800 dark:text-white">
              Create Your Account
            </CardTitle>
            <CardDescription className="text-gray-600 dark:text-gray-300">
              Join us today and get started with amazing features
            </CardDescription>
          </CardHeader>
          
          <CardContent>
            <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">

               <div className="space-y-3">
                <Label htmlFor="email" className="text-gray-700 dark:text-gray-300 font-medium">
                  First Name
                </Label>
                <div className="relative">
                  <User className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                  <Input
                    id="first_name"
                    type="text"
                    placeholder="John"
                    className="pl-10 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-emerald-500 dark:focus:border-emerald-400 transition-colors"
                    {...register("first_name", { required: true })}
                  />
                </div>
              </div>

              <div className="space-y-3">
                <Label htmlFor="email" className="text-gray-700 dark:text-gray-300 font-medium">
                  Last Name
                </Label>
                <div className="relative">
                  < User className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                  <Input
                    id="last_name"
                    type="text"
                    placeholder="Doe"
                    className="pl-10 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-emerald-500 dark:focus:border-emerald-400 transition-colors"
                    {...register("last_name", { required: true })}
                  />
                </div>
              </div>

              <div className="space-y-3">
                <Label htmlFor="email" className="text-gray-700 dark:text-gray-300 font-medium">
                  Email Address
                </Label>
                <div className="relative">
                  <Mail className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                  <Input
                    id="email"
                    type="email"
                    placeholder="you@example.com"
                    className="pl-10 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-emerald-500 dark:focus:border-emerald-400 transition-colors"
                    {...register("email", { required: true })}
                  />
                </div>
              </div>
              
              <div className="space-y-3">
                <Label htmlFor="password" className="text-gray-700 dark:text-gray-300 font-medium">
                  Password
                </Label>
                <div className="relative">
                  <Lock className="absolute left-3 top-3 h-5 w-5 text-gray-400" />
                  <Input
                    id="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Create a strong password"
                    className="pl-10 pr-12 h-12 bg-white/50 dark:bg-gray-700/50 border-gray-300 dark:border-gray-600 focus:border-emerald-500 dark:focus:border-emerald-400 transition-colors"
                    {...register("password", { required: true })}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword((prev) => !prev)}
                    className="absolute right-3 top-3 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 transition-colors"
                  >
                    {showPassword ? (
                      <EyeOff size={20} className="stroke-current" />
                    ) : (
                      <Eye size={20} className="stroke-current" />
                    )}
                  </button>
                </div>
                <div className="flex items-start mt-2">
                  <Shield className="h-4 w-4 text-emerald-500 mr-2 mt-0.5" />
                  <p className="text-xs text-gray-500 dark:text-gray-400">
                    Use at least 8 characters with a mix of letters, numbers & symbols
                  </p>
                </div>
              </div>

              {/* Hidden role field - still functional but hidden */}
              <input type="hidden" {...register("role")} />

              <div className="space-y-3">
                <Label className="text-gray-700 dark:text-gray-300 font-medium">
                  Account Type
                </Label>
                <div className="flex items-center justify-between p-3 bg-gradient-to-r from-emerald-50 to-cyan-50 dark:from-gray-700/50 dark:to-gray-800/50 rounded-lg border border-emerald-200 dark:border-emerald-800/50">
                  <div className="flex items-center space-x-3">
                    <div className="h-10 w-10 rounded-full bg-gradient-to-r from-emerald-500 to-cyan-500 flex items-center justify-center">
                      <Users className="h-5 w-5 text-white" />
                    </div>
                    <div>
                      <p className="font-semibold text-gray-800 dark:text-white">Administrator</p>
                      <p className="text-sm text-gray-600 dark:text-gray-400">Full system access</p>
                    </div>
                  </div>
                  <div className="px-3 py-1 bg-emerald-100 dark:bg-emerald-900/30 text-emerald-700 dark:text-emerald-300 rounded-full text-sm font-medium">
                    Default
                  </div>
                </div>
              </div>

              <Button 
                type="submit" 
                className="w-full h-12 mt-2 bg-gradient-to-r from-emerald-600 to-cyan-600 hover:from-emerald-700 hover:to-cyan-700 text-white font-semibold shadow-lg shadow-emerald-500/25 dark:shadow-emerald-500/15 transition-all duration-300 hover:shadow-xl hover:shadow-emerald-500/35 disabled:opacity-50 disabled:cursor-not-allowed group"
                disabled={loading}
              >
                {loading ? (
                  <div className="flex items-center justify-center">
                    <div className="h-5 w-5 animate-spin rounded-full border-2 border-white border-t-transparent"></div>
                    <span className="ml-2">Creating Account...</span>
                  </div>
                ) : (
                  <>
                    <UserPlus className="mr-2 h-5 w-5 group-hover:scale-110 transition-transform" />
                    Create Account
                  </>
                )}
              </Button>
            </form>
          </CardContent>
          
          <CardFooter className="flex justify-center pt-6 border-t border-gray-100 dark:border-gray-700">
            <p className="text-gray-600 dark:text-gray-400 text-sm">
              Already have an account?{" "}
              <Button
                variant="link"
                className="p-0 h-auto font-semibold text-emerald-600 dark:text-emerald-400 hover:text-emerald-700 dark:hover:text-emerald-300 transition-colors"
                onClick={() => {
                  console.log("Register.tsx: Navigate to login button clicked");
                  navigate("/login");
                }}
              >
                Sign in here
              </Button>
            </p>
          </CardFooter>
        </Card>
        
        {/* Additional Info */}
        <div className="mt-8 text-center">
          <div className="grid grid-cols-3 gap-4 mb-4">
            <div className="text-center">
              <div className="h-8 w-8 mx-auto mb-2 rounded-full bg-emerald-100 dark:bg-emerald-900/30 flex items-center justify-center">
                <Shield className="h-4 w-4 text-emerald-600 dark:text-emerald-400" />
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">Secure</p>
            </div>
            <div className="text-center">
              <div className="h-8 w-8 mx-auto mb-2 rounded-full bg-cyan-100 dark:bg-cyan-900/30 flex items-center justify-center">
                <Lock className="h-4 w-4 text-cyan-600 dark:text-cyan-400" />
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">Encrypted</p>
            </div>
            <div className="text-center">
              <div className="h-8 w-8 mx-auto mb-2 rounded-full bg-blue-100 dark:bg-blue-900/30 flex items-center justify-center">
                <Users className="h-4 w-4 text-blue-600 dark:text-blue-400" />
              </div>
              <p className="text-xs text-gray-600 dark:text-gray-400">Reliable</p>
            </div>
          </div>
          <p className="text-sm text-gray-500 dark:text-gray-400 opacity-75">
            Join thousands of satisfied users worldwide
          </p>
        </div>
      </div>

      {/* Footer note */}
      <div className="absolute bottom-4 left-0 right-0 text-center">
        <p className="text-xs text-gray-400 dark:text-gray-500">
          Protected by advanced security protocols • © {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}